import { mapGetters } from "vuex";

export default {
  data() {
    return {
      fieldConditions: []
    };
  },
  computed: {
    ...mapGetters("featureFlag", ["allFlags"])
  }
};
